import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-sm-12" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-header pb-0" }
const _hoisted_6 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = { class: "row mb-4" }
const _hoisted_10 = { class: "col-md-4" }
const _hoisted_11 = { class: "input-group" }
const _hoisted_12 = { class: "col-md-3" }
const _hoisted_13 = { class: "col-md-3" }
const _hoisted_14 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_15 = {
  key: 1,
  class: "table-responsive table_style"
}
const _hoisted_16 = { class: "table table-striped table-hover align-middle" }
const _hoisted_17 = { class: "table-group-divider" }
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = { class: "badge bg-secondary" }
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = ["title"]
const _hoisted_22 = { class: "text-center" }
const _hoisted_23 = ["title"]
const _hoisted_24 = { class: "bg-light px-2 py-1 rounded" }
const _hoisted_25 = { class: "text-muted" }
const _hoisted_26 = { class: "text-center" }
const _hoisted_27 = { class: "badge bg-info" }
const _hoisted_28 = { class: "text-center" }
const _hoisted_29 = { class: "form-check form-switch" }
const _hoisted_30 = ["checked", "onChange", "disabled"]
const _hoisted_31 = { class: "form-check-label text-xs" }
const _hoisted_32 = { class: "text-muted" }
const _hoisted_33 = {
  class: "d-flex gap-2",
  role: "group"
}
const _hoisted_34 = ["onClick", "disabled"]
const _hoisted_35 = ["onClick", "disabled"]
const _hoisted_36 = ["onClick", "disabled"]
const _hoisted_37 = {
  key: 2,
  class: "text-center py-5"
}
const _hoisted_38 = ["disabled"]
const _hoisted_39 = {
  key: 3,
  class: "d-flex justify-content-between align-items-center mt-4 pt-3 border-top"
}
const _hoisted_40 = { class: "text-muted" }
const _hoisted_41 = {
  key: 0,
  "aria-label": "Categories pagination"
}
const _hoisted_42 = { class: "pagination pagination-sm mb-0" }
const _hoisted_43 = ["disabled"]
const _hoisted_44 = ["onClick", "aria-label", "aria-current"]
const _hoisted_45 = {
  key: 1,
  class: "page-link"
}
const _hoisted_46 = ["disabled"]

import { ref, computed, onMounted, defineAsyncComponent } from "vue";
import { toast } from "vue3-toastify";
import apiService from "@/services/apiService";
import { usePermissions } from "@/composables/usePermissions";


export default /*@__PURE__*/_defineComponent({
  __name: 'PackageCategoriesList',
  setup(__props) {

const { canView, canCreate, canUpdate, canDelete } = usePermissions();

const PackageCategoryModal = defineAsyncComponent(
  () => import("@/components/theme/admin/packages/PackageCategoryModal.vue")
);

const PackageCategoryViewModal = defineAsyncComponent(
  () => import("@/components/theme/admin/packages/PackageCategoryViewModal.vue")
);

// State
const categories = ref<any[]>([]);
const loading = ref(false);
const searchQuery = ref("");
const filterStatus = ref("");
const sortBy = ref("sortOrder");
const currentPage = ref(1);
const itemsPerPage = ref(10);
const totalItems = ref(0);

// Modal state
const showModal = ref(false);
const showViewModal = ref(false);
const selectedCategory = ref<any>(null);
const isEditMode = ref(false);

// Computed
const totalPages = computed(() =>
  Math.ceil(totalItems.value / itemsPerPage.value)
);

const startItem = computed(
  () => (currentPage.value - 1) * itemsPerPage.value + 1
);

const endItem = computed(() =>
  Math.min(currentPage.value * itemsPerPage.value, totalItems.value)
);

const visiblePages = computed(() => {
  const delta = 2;
  const range = [];
  const rangeWithDots = [];

  if (totalPages.value <= 1) {
    return [1];
  }

  if (totalPages.value <= 7) {
    // Show all pages if total is 7 or less
    for (let i = 1; i <= totalPages.value; i++) {
      range.push(i);
    }
    return range;
  }

  for (
    let i = Math.max(2, currentPage.value - delta);
    i <= Math.min(totalPages.value - 1, currentPage.value + delta);
    i++
  ) {
    range.push(i);
  }

  if (currentPage.value - delta > 2) {
    rangeWithDots.push(1, "...");
  } else {
    rangeWithDots.push(1);
  }

  rangeWithDots.push(...range);

  if (currentPage.value + delta < totalPages.value - 1) {
    rangeWithDots.push("...", totalPages.value);
  } else if (totalPages.value > 1) {
    rangeWithDots.push(totalPages.value);
  }

  return rangeWithDots.filter(
    (page, index, array) => array.indexOf(page) === index
  );
});

// Methods
const fetchCategories = async () => {
  try {
    loading.value = true;
    const params: any = {
      page: currentPage.value,
      limit: itemsPerPage.value,
    };

    if (searchQuery.value) {
      params.search = searchQuery.value;
    }

    if (filterStatus.value !== "") {
      params.isActive = filterStatus.value;
    }

    if (sortBy.value) {
      params.sortBy = sortBy.value;
    }

    const response = await apiService.getPackageCategories(params);

    // Handle the nested response structure
    if (response.data && response.data.categories) {
      categories.value = response.data.categories;
      totalItems.value =
        response.data.pagination?.totalItems || response.data.categories.length;
    } else if (response.categories) {
      // Fallback if response structure is different
      categories.value = response.categories;
      totalItems.value =
        response.pagination?.totalItems || response.categories.length;
    } else {
      // Fallback for direct array response
      categories.value = response.data || response || [];
      totalItems.value =
        response.total || response.pagination?.total || categories.value.length;
    }
  } catch (error) {
    console.error("Error fetching package categories:", error);
    toast.error("Failed to load package categories");
  } finally {
    loading.value = false;
  }
};

const handleSearch = () => {
  currentPage.value = 1;
  fetchCategories();
};

const handleFilter = () => {
  currentPage.value = 1;
  fetchCategories();
};

const resetFilters = () => {
  searchQuery.value = "";
  filterStatus.value = "";
  sortBy.value = "sortOrder";
  currentPage.value = 1;
  fetchCategories();
};

const changePage = (page: number) => {
  if (page >= 1 && page <= totalPages.value) {
    currentPage.value = page;
    fetchCategories();
  }
};

const openCreateModal = () => {
  selectedCategory.value = null;
  isEditMode.value = false;
  showModal.value = true;
};

const editCategory = (category: any) => {
  selectedCategory.value = { ...category };
  isEditMode.value = true;
  showModal.value = true;
};

const viewCategory = (category: any) => {
  selectedCategory.value = category;
  showViewModal.value = true;
};

const closeModal = () => {
  showModal.value = false;
  selectedCategory.value = null;
  isEditMode.value = false;
};

const closeViewModal = () => {
  showViewModal.value = false;
  selectedCategory.value = null;
};

const handleCategorySaved = () => {
  fetchCategories();
  closeModal();
  toast.success(
    isEditMode.value
      ? "Category updated successfully"
      : "Category created successfully"
  );
};

const handleToggleStatus = (id: string, event: Event) => {
  const target = event.target as HTMLInputElement;
  toggleStatus(id, target.checked);
};

const toggleStatus = async (id: string, status: boolean) => {
  try {
    // Optimistic update - update UI immediately
    const categoryIndex = categories.value.findIndex((cat) => cat._id === id);
    if (categoryIndex !== -1) {
      categories.value[categoryIndex].isActive = status;
    }

    await apiService.togglePackageCategoryStatus(id);
    toast.success(
      `Category ${status ? "activated" : "deactivated"} successfully`
    );

    // Refresh data to ensure consistency
    await fetchCategories();
  } catch (error) {
    console.error("Error toggling status:", error);
    toast.error("Failed to update category status");

    // Revert optimistic update on error
    const categoryIndex = categories.value.findIndex((cat) => cat._id === id);
    if (categoryIndex !== -1) {
      categories.value[categoryIndex].isActive = !status;
    }
  }
};

const deleteCategory = async (id: string) => {
  if (
    !confirm(
      "Are you sure you want to delete this category? This action cannot be undone."
    )
  ) {
    return;
  }

  try {
    await apiService.deletePackageCategory(id);
    await fetchCategories();
    toast.success("Category deleted successfully");
  } catch (error) {
    console.error("Error deleting category:", error);
    toast.error("Failed to delete category");
  }
};

const formatDate = (date: string) => {
  if (!date) return "N/A";
  return new Date(date).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

// Lifecycle
onMounted(() => {
  fetchCategories();
});

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Breadcrumbs, { title: "Package Categories" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _cache[6] || (_cache[6] = _createElementVNode("h4", { class: "mb-0" }, [
                  _createElementVNode("i", { class: "fas fa-tags me-2" }),
                  _createTextVNode(" Package Categories Management ")
                ], -1)),
                _createElementVNode("button", {
                  class: "btn btn-primary",
                  onClick: openCreateModal,
                  disabled: !_unref(canCreate)('packages')
                }, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("i", { class: "fas fa-plus me-1" }, null, -1),
                  _createTextVNode(" Create Category ", -1)
                ]))], 8, _hoisted_7)
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _cache[7] || (_cache[7] = _createElementVNode("span", { class: "input-group-text" }, [
                      _createElementVNode("i", { class: "fas fa-search" })
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
                      type: "text",
                      class: "form-control",
                      placeholder: "Search categories...",
                      onInput: handleSearch
                    }, null, 544), [
                      [_vModelText, searchQuery.value]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filterStatus).value = $event)),
                    class: "form-select",
                    onChange: handleFilter
                  }, [...(_cache[8] || (_cache[8] = [
                    _createElementVNode("option", { value: "" }, "All Status", -1),
                    _createElementVNode("option", { value: "true" }, "Active", -1),
                    _createElementVNode("option", { value: "false" }, "Inactive", -1)
                  ]))], 544), [
                    [_vModelSelect, filterStatus.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((sortBy).value = $event)),
                    class: "form-select",
                    onChange: handleFilter
                  }, [...(_cache[9] || (_cache[9] = [
                    _createElementVNode("option", { value: "sortOrder" }, "Sort Order", -1),
                    _createElementVNode("option", { value: "name" }, "Name", -1),
                    _createElementVNode("option", { value: "created_at" }, "Created Date", -1),
                    _createElementVNode("option", { value: "updated_at" }, "Updated Date", -1)
                  ]))], 544), [
                    [_vModelSelect, sortBy.value]
                  ])
                ]),
                _createElementVNode("div", { class: "col-md-2" }, [
                  _createElementVNode("button", {
                    class: "btn btn-outline-secondary w-100",
                    onClick: resetFilters,
                    title: "Reset Filters"
                  }, [...(_cache[10] || (_cache[10] = [
                    _createElementVNode("i", { class: "fas fa-undo" }, null, -1)
                  ]))])
                ])
              ]),
              (loading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[11] || (_cache[11] = [
                    _createElementVNode("div", {
                      class: "spinner-border text-primary",
                      role: "status"
                    }, [
                      _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                    ], -1)
                  ]))]))
                : (categories.value.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("table", _hoisted_16, [
                        _cache[15] || (_cache[15] = _createElementVNode("thead", { class: "table-dark" }, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", {
                              scope: "col",
                              style: {"width":"80px"}
                            }, "Sr No"),
                            _createElementVNode("th", {
                              scope: "col",
                              style: {"width":"80px"}
                            }, "Color"),
                            _createElementVNode("th", {
                              scope: "col",
                              style: {"width":"80px"}
                            }, "Icon"),
                            _createElementVNode("th", {
                              scope: "col",
                              style: {"min-width":"200px"}
                            }, "Name"),
                            _createElementVNode("th", {
                              scope: "col",
                              style: {"width":"150px"}
                            }, "Key"),
                            _createElementVNode("th", {
                              scope: "col",
                              style: {"min-width":"200px"}
                            }, "Description"),
                            _createElementVNode("th", {
                              scope: "col",
                              style: {"width":"150px"}
                            }, "Sort Order"),
                            _createElementVNode("th", {
                              scope: "col",
                              style: {"width":"80px"}
                            }, "Status"),
                            _createElementVNode("th", {
                              scope: "col",
                              style: {"width":"120px"}
                            }, "Created"),
                            _createElementVNode("th", {
                              scope: "col",
                              style: {"width":"150px"}
                            }, "Actions")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", _hoisted_17, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (category, index) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: category._id
                            }, [
                              _createElementVNode("td", _hoisted_18, [
                                _createElementVNode("span", _hoisted_19, _toDisplayString((currentPage.value - 1) * itemsPerPage.value + index + 1), 1)
                              ]),
                              _createElementVNode("td", _hoisted_20, [
                                _createElementVNode("div", {
                                  class: "color-indicator",
                                  style: _normalizeStyle({
                            backgroundColor: category.color || '#6c757d',
                          }),
                                  title: category.color
                                }, null, 12, _hoisted_21)
                              ]),
                              _createElementVNode("td", _hoisted_22, [
                                _createElementVNode("i", {
                                  class: _normalizeClass(`fas fa-${category.icon || 'tag'} text-muted`),
                                  style: {"font-size":"1.2rem"},
                                  title: category.icon
                                }, null, 10, _hoisted_23)
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("strong", null, _toDisplayString(category.name), 1)
                                ])
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("code", _hoisted_24, _toDisplayString(category.key), 1)
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("span", _hoisted_25, _toDisplayString(category.description || "No description"), 1)
                              ]),
                              _createElementVNode("td", _hoisted_26, [
                                _createElementVNode("span", _hoisted_27, _toDisplayString(category.sortOrder || 0), 1)
                              ]),
                              _createElementVNode("td", _hoisted_28, [
                                _createElementVNode("div", _hoisted_29, [
                                  _createElementVNode("input", {
                                    class: "form-check-input",
                                    type: "checkbox",
                                    checked: category.isActive,
                                    onChange: ($event: any) => (handleToggleStatus(category._id, $event)),
                                    disabled: loading.value || !_unref(canUpdate)('packages')
                                  }, null, 40, _hoisted_30),
                                  _createElementVNode("label", _hoisted_31, _toDisplayString(category.isActive ? "Active" : "Inactive"), 1)
                                ])
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("small", _hoisted_32, _toDisplayString(category.createdAt
                              ? formatDate(category.createdAt)
                              : "N/A"), 1)
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_33, [
                                  _createElementVNode("button", {
                                    class: "btn btn-sm btn-outline-primary",
                                    onClick: ($event: any) => (viewCategory(category)),
                                    title: "View",
                                    disabled: !_unref(canView)('packages')
                                  }, [...(_cache[12] || (_cache[12] = [
                                    _createElementVNode("i", { class: "fas fa-eye" }, null, -1)
                                  ]))], 8, _hoisted_34),
                                  _createElementVNode("button", {
                                    class: "btn btn-sm btn-outline-success",
                                    onClick: ($event: any) => (editCategory(category)),
                                    title: "Edit",
                                    disabled: !_unref(canUpdate)('packages')
                                  }, [...(_cache[13] || (_cache[13] = [
                                    _createElementVNode("i", { class: "fas fa-edit" }, null, -1)
                                  ]))], 8, _hoisted_35),
                                  _createElementVNode("button", {
                                    class: "btn btn-sm btn-outline-danger",
                                    onClick: ($event: any) => (deleteCategory(category._id)),
                                    title: "Delete",
                                    disabled: !_unref(canDelete)('packages')
                                  }, [...(_cache[14] || (_cache[14] = [
                                    _createElementVNode("i", { class: "fas fa-trash" }, null, -1)
                                  ]))], 8, _hoisted_36)
                                ])
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                      _cache[17] || (_cache[17] = _createElementVNode("i", { class: "fas fa-tags fa-3x text-muted mb-3" }, null, -1)),
                      _cache[18] || (_cache[18] = _createElementVNode("h5", { class: "text-muted" }, "No package categories found", -1)),
                      _cache[19] || (_cache[19] = _createElementVNode("p", { class: "text-muted" }, " Create your first package category to get started. ", -1)),
                      _createElementVNode("button", {
                        class: "btn btn-primary",
                        onClick: openCreateModal,
                        disabled: !_unref(canCreate)('packages')
                      }, [...(_cache[16] || (_cache[16] = [
                        _createElementVNode("i", { class: "fas fa-plus me-1" }, null, -1),
                        _createTextVNode(" Create Category ", -1)
                      ]))], 8, _hoisted_38)
                    ])),
              (totalItems.value > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("small", null, " Showing " + _toDisplayString(startItem.value) + " to " + _toDisplayString(endItem.value) + " of " + _toDisplayString(totalItems.value) + " categories ", 1)
                    ]),
                    (totalPages.value > 1)
                      ? (_openBlock(), _createElementBlock("nav", _hoisted_41, [
                          _createElementVNode("ul", _hoisted_42, [
                            _createElementVNode("li", {
                              class: _normalizeClass(["page-item", { disabled: currentPage.value <= 1 }])
                            }, [
                              _createElementVNode("button", {
                                class: "page-link",
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (changePage(currentPage.value - 1))),
                                disabled: currentPage.value <= 1,
                                "aria-label": "Previous page"
                              }, [...(_cache[20] || (_cache[20] = [
                                _createElementVNode("i", { class: "fas fa-chevron-left" }, null, -1),
                                _createElementVNode("span", { class: "ms-1 d-none d-sm-inline" }, "Previous", -1)
                              ]))], 8, _hoisted_43)
                            ], 2),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visiblePages.value, (page) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: page,
                                class: _normalizeClass(["page-item", { active: page === currentPage.value }])
                              }, [
                                (typeof page === 'number')
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      class: "page-link",
                                      onClick: ($event: any) => (changePage(page)),
                                      "aria-label": `Go to page ${page}`,
                                      "aria-current": 
                          page === currentPage.value ? 'page' : undefined
                        
                                    }, _toDisplayString(page), 9, _hoisted_44))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(page), 1))
                              ], 2))
                            }), 128)),
                            _createElementVNode("li", {
                              class: _normalizeClass(["page-item", { disabled: currentPage.value >= totalPages.value }])
                            }, [
                              _createElementVNode("button", {
                                class: "page-link",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (changePage(currentPage.value + 1))),
                                disabled: currentPage.value >= totalPages.value,
                                "aria-label": "Next page"
                              }, [...(_cache[21] || (_cache[21] = [
                                _createElementVNode("span", { class: "me-1 d-none d-sm-inline" }, "Next", -1),
                                _createElementVNode("i", { class: "fas fa-chevron-right" }, null, -1)
                              ]))], 8, _hoisted_46)
                            ], 2)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    (showModal.value)
      ? (_openBlock(), _createBlock(_unref(PackageCategoryModal), {
          key: 0,
          show: showModal.value,
          category: selectedCategory.value,
          "is-edit": isEditMode.value,
          onClose: closeModal,
          onSaved: handleCategorySaved
        }, null, 8, ["show", "category", "is-edit"]))
      : _createCommentVNode("", true),
    (showViewModal.value)
      ? (_openBlock(), _createBlock(_unref(PackageCategoryViewModal), {
          key: 1,
          show: showViewModal.value,
          category: selectedCategory.value,
          onClose: closeViewModal
        }, null, 8, ["show", "category"]))
      : _createCommentVNode("", true)
  ]))
}
}

})